import { Divider, Grid, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Button, DialogState, FileUpload, FileUploadArea, FileUploadAreaWithDownload, createAutocompleteAddressField, createCurrencyField, createDateField, createRadioField, createSelectField, createTextField } from '@roc/ui';
import { stateOptions } from 'libs/client-portal-shared/src/app/modules/bridgePricer/utils/bridgePricerConstants';
import { useEffect, useState } from 'react';
import PropertyInformationFormLineItem from 'libs/ui/src/lib/components/borrowerBaseballCard/propertyInformationFormLineItem';
import { useRocInternalPortalStore } from 'apps/roc-internal-portal/src/app/hooks';
import { useBorrowerBaseballCardStore } from 'libs/feature-borrowers/src/borrowers/hooks/useBorrowerBaseballCardStore';
import PublicTrackRecordLineItem from 'libs/ui/src/lib/components/borrowerBaseballCard/publicTrackRecordLineItem';

const useStyles = makeStyles((theme: Theme) => {
  return {
    button: {
      marginRight: theme.spacing(1)
    }
  };
});

export const dealTypeOptions = [
  {
    label: 'Bridge',
    value: 'Bridge',
  },
  {
    label: 'Rental',
    value: 'Rental',
  },
  {
    label: 'Ground Up',
    value: 'Ground Up'
  }
];

export const screenTypeOptions = [
  {
    label: 'Look up by Entity Name',
    value: 'entityName',
  },
  {
    label: 'Look up by Property Address',
    value: 'propertyAddress',
  },
];

export const TrackRecordPropertyForm = observer(({ store, handleClose, borrowerBaseballCardStore }) => {
  const classes = useStyles();
  const formStore = store.trackRecordPropertyFormStore;

  const handleAddressChange = event => {
    const { value, fullInfo } = event?.target || {};
    const { address_components, geometry } = fullInfo || {};
    formStore.saveAddressField(value, address_components, geometry);
  };

  const getItemListFromBothSets = () => {
    const firstArray = store.currentDocumentsToUpload;
    const secondArray = store.currentTasks;

    const mergedArray = firstArray.map((itemA) => {
      const itemB = secondArray.find((itemB) => itemB.originalFileName === itemA.name);
      return itemB ? { ...itemA, taskId: itemB.taskId, originalFileName: itemB.originalFileName, fileExtension: itemB.fileExtension }
        : itemA;
    })
    return mergedArray;
  }

  useEffect(() => {
    borrowerBaseballCardStore.currentBorrower = store?.borrowerInfo?.borrowerId;
    if (borrowerBaseballCardStore.propagateAddress) {
      if (borrowerBaseballCardStore?.propertyFormStore?.form?.fields?.purchaseAddress?.value !== '') {
        formStore.onFieldChange('fullAddress', borrowerBaseballCardStore?.propertyFormStore?.form?.fields?.purchaseAddress?.value);
        formStore.onFieldChange('purchaseAddress', borrowerBaseballCardStore?.propertyFormStore?.form?.fields?.purchaseAddress?.value);
        formStore.onFieldChange('purchaseState', borrowerBaseballCardStore?.propertyFormStore?.form?.fields?.purchaseState?.value);
        formStore.onFieldChange('purchaseZipcode', borrowerBaseballCardStore?.propertyFormStore?.form?.fields?.purchaseZipcode?.value);
        formStore.onFieldChange('purchaseCity', borrowerBaseballCardStore?.propertyFormStore?.form?.fields?.purchaseCity?.value);
      }
    }
  }, [borrowerBaseballCardStore.propagateAddress])

  return (
    <Grid container direction='row' spacing={2}>
      <Grid item xs={12}>
        {/* <Typography variant='h5'>{`Property #${store.currentPropertyIndex}`}</Typography> */}
        <Typography variant='h4'>{`Property Details`}</Typography>
      </Grid>
      {borrowerBaseballCardStore.propertyInformationDialogState == DialogState.ADD && <Grid item xs={12} style={{ paddingTop: '8px' }}>
        {createRadioField({
          store: formStore,
          testId: 'screenType',
          fieldName: 'screenType',
          label: "How would you like to add the property?",
          options: screenTypeOptions,
          row: true,
        })}
      </Grid>}
      {formStore.form.fields.screenType.value === 'propertyAddress' ? (
        <>
          {<PropertyInformationFormLineItem store={borrowerBaseballCardStore}
            title='Property Details' doPropertyLookup={true} onClose={handleClose} formStore={formStore} />}
        </>
      ) : formStore.form.fields.screenType.value === 'entityName' ? (
        <>
          {<PublicTrackRecordLineItem store={borrowerBaseballCardStore} isOpen={store.isPropertyFormActive} handleClose={handleClose} formStore={formStore}/>}
        </>
      ) : <>
        <Grid item xs={12} container direction='row' spacing={1}>
            <Grid item xs={6}>
              {createAutocompleteAddressField({
                fieldName: 'fullAddress',
                label: 'Address Line 1',
                testId: 'fullAddress',
                store: formStore,
                onChange: handleAddressChange,
              })}
            </Grid>
            <Grid item xs={6}>
              {createTextField({
                label: 'Address Line 2',
                fieldName: 'address2',
                testId: 'address2',
                store: formStore,
              })}
            </Grid>
            <Grid item xs={4}>
              {createTextField({
                label: 'City',
                fieldName: 'purchaseCity',
                testId: 'purchaseCity',
                store: formStore,
              })}
            </Grid>
            <Grid item xs={4}>
              {createSelectField({
                store: formStore,
                testId: 'purchaseState',
                fieldName: 'purchaseState',
                label: 'State',
                options: stateOptions,
              })}
            </Grid>
            <Grid item xs={4}>
              {createTextField({
                label: 'Zip Code',
                fieldName: 'purchaseZipcode',
                testId: 'purchaseZipcode',
                store: formStore,
              })}
            </Grid>
            <Grid item xs={6}>
              {createTextField({
                store: formStore,
                testId: 'entityName',
                fieldName: 'entityName',
                label: 'Entity on Title',
              })}
              </Grid>
            <Grid item xs={6}>
              {createSelectField({
                store: formStore,
                testId: 'dealType',
                fieldName: 'dealType',
                label: 'Deal Type',
                options: dealTypeOptions,
              })}
            </Grid>
            {formStore.form.fields.dealType.value != 'Rental' && (
              <>
                <Grid item xs={6}>
                  {createCurrencyField({
                    label: 'Renovation Budget',
                    fieldName: 'rehabBudget',
                    testId: 'rehabBudget',
                    store: formStore,
                  })}
                </Grid>
              </>)}
              <Grid item xs={6}>
                {createCurrencyField({
                  store: formStore,
                  label: 'Purchase Amount',
                  fieldName: 'purchasePrice',
                  testId: 'purchasePrice',
                })}
              </Grid>
            {formStore.form.fields.dealType.value != 'Rental' ?
                (<Grid item xs={6}>
                {createDateField({
                  label: 'Purchase Date',
                  fieldName: 'purchaseDate',
                  testId: 'purchaseDate',
                  format: 'MM/dd/yyyy',
                  store: formStore,
                })}
              </Grid>) :
              (<Grid item xs={6}>
                {createDateField({
                  label: 'Purchase Date',
                  fieldName: 'purchaseDate',
                  testId: 'purchaseDate',
                  format: 'MM/dd/yyyy',
                  store: formStore,
                })}
                </Grid>)}
              <Grid item xs={6}>
                {createTextField({
                  store: formStore,
                  label: 'Seller Name',
                  fieldName: 'purchasedFrom',
                  testId: 'purchasedFrom',
                })}
              </Grid>
              <Grid item xs={6}>
                {createDateField({
                  store: formStore,
                  label: 'Sale Date',
                  fieldName: 'saleDate',
                  testId: 'saleDate',
                })}
              </Grid>
              <Grid item xs={6}>
                {createCurrencyField({
                  store: formStore,
                  label: 'Sale Amount',
                  fieldName: 'salePrice',
                  testId: 'salePrice',
                })}
              </Grid>
            {formStore.form.fields.dealType.value != 'Rental' && (
                <>
              </>
            )}
          </Grid>
          <Grid item xs={12}>
              <span>{`Supporting Documents`}</span>
            </Grid>
            <Grid item xs={12}>
            <FileUploadAreaWithDownload
              items={
                getItemListFromBothSets()
              }
              setItems={(updateFunc) => {
                const updatedItems = updateFunc(store.currentDocumentsToUpload);
                store.currentDocumentsToUpload = updatedItems;
              }}
              multiple={true}
              store={store}
            />
          </Grid>
          <Grid container justifyContent='flex-end'>
            <Button
              variant='outlined'
              color='primary'
                onClick={() => { handleClose(); borrowerBaseballCardStore.setPropagateAddress(false); }}
              testId='removeProperty'
              className={classes.button}
              style={{ backgroundColor: 'transparent' }}
            >
              Cancel
              </Button>
            <Button
              variant="contained"
              color="primary"
                onClick={() => {store.saveTrackRecordProperty(); borrowerBaseballCardStore.setPropagateAddress(false);}}
              testId='saveProperty'
              className={classes.button}
            >
              Save
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Divider variant="fullWidth" />
          </Grid>
      </>}

    </Grid>
  );
});